import { useEffect, useState } from "react";

const LANG_KEY = "autonomo-lang";
const DISABLE_LANGUAGE_SWITCH = true;

const languages = [
  { code: "es", label: "ES" },
  { code: "en", label: "EN" },
];

function hideTranslateBanner() {
  const selectors = [
    ".goog-te-banner-frame",
    "iframe.goog-te-banner-frame",
    "#goog-gt-tt",
  ];
  selectors.forEach((sel) => {
    const el = document.querySelector(sel) as HTMLElement | null;
    if (el) {
      el.style.setProperty("display", "none", "important");
      el.style.setProperty("visibility", "hidden", "important");
    }
  });
  document.body.style.setProperty("top", "0px", "important");
  document.documentElement.style.setProperty("top", "0px", "important");
}

function setTranslateCookie(lang: "es" | "en") {
  const value = `/es/${lang}`;
  const domain = window.location.hostname;
  const expires = ";max-age=31536000"; // 1 año
  document.cookie = `googtrans=${value};path=/${expires}`;
  document.cookie = `googtrans=${value};path=/;domain=${domain}${expires}`;
}

export default function LanguageSwitcher() {
  if (DISABLE_LANGUAGE_SWITCH) {
    return null;
  }

  const [lang, setLang] = useState<"es" | "en">(() => {
    if (typeof window === "undefined") return "es";
    const saved = localStorage.getItem(LANG_KEY);
    return saved === "en" ? "en" : "es";
  });

  useEffect(() => {
    if (typeof document !== "undefined") {
      document.documentElement.lang = lang;
    }
    if (typeof window !== "undefined") {
      hideTranslateBanner();
      const interval = window.setInterval(hideTranslateBanner, 800);
      const timeout = window.setTimeout(() => window.clearInterval(interval), 5000);
      return () => {
        window.clearInterval(interval);
        window.clearTimeout(timeout);
      };
    }
  }, [lang]);

  const handleChange = (code: "es" | "en") => {
    if (DISABLE_LANGUAGE_SWITCH) return;
    setLang(code);
    localStorage.setItem(LANG_KEY, code);
    if (typeof window !== "undefined") {
      setTranslateCookie(code);
      window.location.reload();
    }
  };

  return (
    <div className="notranslate" translate="no" style={{ display: "flex", alignItems: "center", gap: "6px" }}>
      <span translate="no" style={{ fontSize: "12px", color: "var(--muted)", fontWeight: 600 }}>Idioma</span>
      <div translate="no" style={{ display: "inline-flex", border: "1px solid var(--border)", borderRadius: "10px", overflow: "hidden" }}>
        {languages.map((l) => (
          <button
            key={l.code}
            onClick={() => handleChange(l.code as "es" | "en")}
            disabled={DISABLE_LANGUAGE_SWITCH}
            style={{
              appearance: "none",
              border: "none",
              background: lang === l.code ? "var(--brand-soft)" : "transparent",
              color: lang === l.code ? "var(--brand-ink)" : "var(--muted)",
              padding: "6px 10px",
              fontSize: "12px",
              fontWeight: 700,
              cursor: DISABLE_LANGUAGE_SWITCH ? "not-allowed" : "pointer",
              transition: "all 0.15s ease",
              opacity: DISABLE_LANGUAGE_SWITCH ? 0.6 : 1,
            }}
            aria-pressed={lang === l.code}
            aria-disabled={DISABLE_LANGUAGE_SWITCH}
            translate="no"
          >
            {l.label}
          </button>
        ))}
      </div>
    </div>
  );
}
